import React, { useState } from 'react'
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import styled from 'styled-components'
import { Header } from './atoms/header'
import { SubHeader } from './atoms/subheader'
import { TabPanel } from './atoms/tabPanel'
import { IncomeAndExpenses } from './organisms/incomeAndExpenses'
import { Result } from './organisms/result'
import { ThirdPartyExpenses } from './organisms/thirdPartyExpenses'
import { theme } from './theme'

const initialState = {
	grossIncome: '',
	paysINSS: '',
	paysPGBL: '',
	previdencyYearlyContribution: '',
	averageMedicalYearlyExpenses: '',
	ownEducationYearlyExpenses: '',
	paysAlimony: '',
	alimonyYearlyExpenses: '',
	dependentCount: '',
	dependents: [],
}

// const initialState = {
//   grossIncome: 22500,
//   paysINSS: 'Sim',
//   paysPGBL: 'Não',
//   previdencyYearlyContribution: 0,
//   averageMedicalYearlyExpenses: 0,
//   ownEducationYearlyExpenses: 6000,
//   paysAlimony: 'Não',
//   alimonyYearlyExpenses: 0,
//   dependentCount: '2',
//   dependents: ['1000', '1000'],
// }

function App() {
  const [hasConverted, setHasConverted] = useState(false)

  const [stepState, setStepState] = useState({
    index: 0,
    enable: 0
  })
  const [data, setData] = useState(initialState)

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={theme}>
        <Header theme={theme}/>
        <SubHeader theme={theme} stepState={stepState} setStepState={setStepState}/>

        <Container>
          <TabPanel theme={theme} stepState={stepState} index={0}>
            <IncomeAndExpenses stepState={stepState} setStepState={setStepState} data={data} setData={setData}/>
          </TabPanel>
          <TabPanel theme={theme} stepState={stepState} index={1}>
            <ThirdPartyExpenses hasConverted={hasConverted} setHasConverted={setHasConverted} stepState={stepState} setStepState={setStepState} data={data} setData={setData}/>
          </TabPanel>
          <TabPanel theme={theme} stepState={stepState} index={2}>
            <Result stepState={stepState} setStepState={setStepState} data={data} setData={setData}/>
          </TabPanel>
        </Container>
      </ThemeProvider>
    </StyledEngineProvider>
  );
}

const Container = styled.div`
  box-sizing: border-box;
  width: 100%;
  padding: 40px 20px;

  @media (max-width: 767px) {
    padding: 20px 16px;
  }
`

export default App
